import React, { useEffect, useState } from "react";

export default function ListaMembriPunctaj() {
  const [membri, setMembri] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchMembri() {
      try {
        const res = await fetch("https://prdp-api.suport-949.workers.dev/api/membri", {
          headers: {
            Authorization: "Bearer unwantedtok",
          },
        });
        if (!res.ok) throw new Error("Eroare la încărcarea membrilor");
        const data = await res.json();
        // sortează descrescător după puncte
        data.sort((a, b) => (b.puncte || 0) - (a.puncte || 0));
        setMembri(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchMembri();
  }, []);

  if (loading) return <div>Se încarcă lista membrilor...</div>;
  if (error) return <div className="text-danger">Eroare: {error}</div>;
  if (membri.length === 0) return <div>Nu există membri înregistrati.</div>;

  return (
    <div>
      <h3 className="mb-4" style={{ color: "#01358D", fontWeight: "700" }}>
        Lista membrilor cu punctajul aferent
      </h3>
      <div className="list-group" style={{ maxHeight: "600px", overflowY: "auto", boxShadow: "0 4px 12px rgb(0 0 0 / 0.1)" }}>
        {membri.map(({ id, nume, prenume, puncte }) => (
          <div
            key={id}
            className="list-group-item d-flex justify-content-between align-items-center"
            style={{
              borderRadius: 12,
              marginBottom: 8,
              background: "linear-gradient(90deg, #e4ebff 0%, #f0f6ff 100%)",
              boxShadow: "2px 4px 6px rgb(0 0 0 / 0.05)",
              padding: "16px 24px",
              fontWeight: 600,
              fontSize: "1.1rem",
              cursor: "default",
              userSelect: "none",
            }}
          >
            <div style={{ color: "#0b277e" }}>
              {prenume} {nume}
            </div>
            <div
              style={{
                backgroundColor: "#01358D",
                color: "#fff",
                borderRadius: "9999px",
                padding: "6px 18px",
                fontWeight: "700",
                fontSize: "1rem",
                minWidth: 60,
                textAlign: "center",
                boxShadow: "0 2px 6px rgb(1 53 141 / 0.5)",
              }}
            >
              {puncte ?? 0} pt.
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
